/* eslint-disable import/prefer-default-export */
export const selectDateFilter = (state) => state.dateFilter;
